import React from 'react';

/** Surface container. `outline` for list cards, `shadow` for elevated cards. */
export function Card({ children, variant = 'outline', padding = 20, radius = 'var(--radius-lg)', interactive = false, style, ...rest }) {
  const look =
    variant === 'shadow'
      ? { boxShadow: 'var(--shadow-normal)', background: 'var(--background-elevated-normal)' }
      : variant === 'filled'
      ? { background: 'var(--background-normal-alternative)' }
      : { boxShadow: 'inset 0 0 0 1px var(--line-normal-neutral)', background: 'var(--background-normal-normal)' };
  return (
    <div
      style={{
        borderRadius: radius,
        padding,
        boxSizing: 'border-box',
        fontFamily: 'var(--font-sans)',
        transition: interactive ? 'box-shadow var(--duration-normal) var(--ease-standard), transform var(--duration-normal) var(--ease-standard)' : undefined,
        cursor: interactive ? 'pointer' : undefined,
        ...look,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
